/* system-cms-prefix start */
const prefix = '/cmsmanager'
/* system-cms-prefix change const prefix = '/cmsadmin' system-cms-prefix change */
/* system-cms-prefix end */

export default {
  // 网站统计网站概况
  statisticsFlowOverview: `${prefix}/statisticsflow/overview`,
  // 趋势分析-图表数据
  statisticsImage: `${prefix}/statisticsflow/image`,
  // 今日访客
  statisticsvisitTimeuser: `${prefix}/statisticsvisit/timeuser`,
  // 访客数据
  statisticsvisitUser: `${prefix}/statisticsvisit/user`,
  // 来源网站
  statisticsSourceSourceUrl: `${prefix}/statisticsSource/sourceUrl`,
  // 入口页面
  statisticsAccessPageEntrancePage: `${prefix}/statisticsAccessPage/entrancePage`,
  // 访问页面
  statisticsAccessPageAccessPage: `${prefix}/statisticsAccessPage/accessPage`,
  // 今天地域分布
  statisticsvisitTimearea: `${prefix}/statisticsvisit/timearea`,
  // 地域分布
  statisticsvisitArea: `${prefix}/statisticsvisit/area`,
  // 网站概述新老客户
  statisticsvisitSummarize: `${prefix}/statisticsvisit/summarize`,
  // 网站概述地域分布
  statisticsvisitSummarizeArea: `${prefix}/statisticsvisit/summarizeArea`,
  // 实时访客图表数据
  statisticsflowRealtime: `${prefix}/statisticsflow/realtime`,
  // 实时访客图表数据
  statisticsflowRealtimePage: `${prefix}/statisticsflow/realtime/page`,
  // 来源网站分页
  statisticsSourceSourceUrlPage: `${prefix}/statisticsSource/sourceUrl/page`,
  // 趋势分析-列表数据
  statisticsflowPage: `${prefix}/statisticsflow/page`,
  // 来源分析-来源类型
  statisticsSourceType: `${prefix}/statisticsSource/sourceType`,
  // 来源分析-来源网站分页
  statisticsSourceUrlPage: `${prefix}/statisticsSource/sourceUrl/page`,
  // 来源分析-搜索引擎
  statisticsSourceSearchEngine: `${prefix}/statisticsSource/searchEngine`,
  // 来源分析-外部链接（域名）
  statisticsSourceDomain: `${prefix}/statisticsSource/domain`,
  // 来源分析-外部链接（url）
  statisticsSourceUrl: `${prefix}/statisticsSource/url`,
  // 来源分析-外部链接（域名）分页
  statisticsSourceDomainPage: `${prefix}/statisticsSource/domain/page`,
  // 来源分析-外部链接（url）分页
  statisticsSourceUrlOuterPage: `${prefix}/statisticsSource/url/page`,
  // 地域分布-今天列表分页
  statisticsvisitTimepage: `${prefix}/statisticsvisit/timepage`,
  // 地域分布-日常列表分页
  statisticsvisitAreapage: `${prefix}/statisticsvisit/areapage`,
  // 今日设备-图表信息
  statisticsdeviceTimedevice: `${prefix}/statisticsdevice/timedevice`,
  // 今日设备-列表信息
  statisticsdeviceTime: `${prefix}/statisticsdevice/time`,
  // 今日设备-日常图表信息
  statisticsdeviceDevice: `${prefix}/statisticsdevice/device`,
  // 今日设备-日常列表信息
  statisticsdeviceDevices: `${prefix}/statisticsdevice/devices`,
  // 忠诚度-今日访问次数
  statisticsaccessTimePage: `${prefix}/statisticsaccess/timePage`,
  // 忠诚度-访问次数
  statisticsaccessPageInfo: `${prefix}/statisticsaccess/pageInfo`,
  // 忠诚度-今日访问深度
  statisticsaccessTimeHigh: `${prefix}/statisticsaccess/timeHigh`,
  // 忠诚度-访问深度
  statisticsaccessHighInfo: `${prefix}/statisticsaccess/highInfo`,
  // 忠诚度-今日访问时长
  statisticsaccessTime: `${prefix}/statisticsaccess/time`,
  // 忠诚度-访问时长
  statisticsaccessTimeInfo: `${prefix}/statisticsaccess/timeInfo`,
  // 实时访客-在线访问人数
  statisticsflowRealtimeUvnum: `${prefix}/statisticsflow/realtime/uvnum`,
  // 网站信息统计
  statisticsSitegeneralInfo: `${prefix}/sitegeneral/info`,
  // 流量贡献值
  statisticsSitegeneralViews: `${prefix}/sitegeneral/views`,
  // 内容发布统计-栏目饼图、柱形图
  statisticsSitegeneralChannel: `${prefix}/sitegeneral/channel`,
  // 内容发布统计-栏目表格
  statisticsSitegeneralChannelData: `${prefix}/sitegeneral/channel/data`,
  // 内容发布统计-用户饼图、柱形图
  statisticsSitegeneralUser: `${prefix}/sitegeneral/user`,
  // 内容发布统计-用户表格
  statisticsSitegeneralUserData: `${prefix}/sitegeneral/user/data`,
  // 内容发布统计-用户表格导出
  statisticsUserExcelData: `${prefix}/sitegeneral/excel/user`,
  // 内容发布统计-组织饼图、柱形图
  statisticsSitegeneralOrg: `${prefix}/sitegeneral/org`,
  // 内容发布统计-组织表格
  statisticsSitegeneralOrgData: `${prefix}/sitegeneral/org/data`,
  // 内容发布统计-组织表格导出
  statisticsOrgExcelData: `${prefix}/sitegeneral/excel/org`,
  // 内容发布统计-组织表格导出
  statisticsSitegeneralSite: `${prefix}/sitegeneral/site`,
  // 内容发布统计-组织表格
  statisticsSitegeneralSiteData: `${prefix}/sitegeneral/site/data`,
  // 内容数据统计-按栏目表格
  sitegeneralChannelData: `${prefix}/sitegeneral/statistics/channel`,
  // 内容数据统计-按单篇内容 sitegeneral/statistics/data
  sitegeneralContentData: `${prefix}/sitegeneral/statistics/content`,
  // 内容数据统计-按单篇内容 sitegeneral/statistics/data
  sitegeneralListData: `${prefix}/sitegeneral/statistics/data`
}
